export default __webpack_public_path__ + "static/media/eyes_l.b898d027.png";